export function getTranslationForBox(itemName, boxType, t, detailItemName = '') {
    let keyWithBox = itemName + "_box_" + boxType + detailItemName;
    const translatedTextWithBox = t(keyWithBox);
    return (translatedTextWithBox === keyWithBox ? t(itemName + detailItemName) : t(keyWithBox))
}